import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import {
  SignUpAction,
  SignUpByPhoneAction,
  SignUpResponse,
} from '@triare/auth-redux/dist/saga/auth/signUp';
import { useAuth } from '../../../../store/auth';
import OTPCode from './OTPCode';

export interface ContentProps {
  onSubmit?: (values: SignUpAction | SignUpByPhoneAction | null) => void;
  setSignInOpen?: () => void;
  onClose?: () => void;
}

export interface SignUpProps {
  content: React.FC<ContentProps>;
  isOpen?: boolean;
  onClose?: () => void;
  onSignInClose?: () => void;
  setSignInOpen?: () => void;
  signUpSuccess?: (payload: SignUpAction) => void;
}

export default function SignUp({
  content: Content,
  isOpen,
  onClose,
  onSignInClose,
  setSignInOpen,
  signUpSuccess,
}: SignUpProps): React.ReactElement {
  const {
    signUp: { response },
  } = useAuth();
  const [state, setState] = useState<SignUpResponse>();
  const [requestData, setRequestData] = useState<
    SignUpAction | SignUpByPhoneAction | null
  >(null);

  useEffect(() => {
    if (isOpen) {
      onSignInClose?.();
    }
  }, [isOpen]);
  useEffect(() => {
    // if (response && response.secretKey) {
    //   setState(response);
    // }

    if (response) {
      setState(response);
      onClose?.();
      signUpSuccess?.(requestData as SignUpAction);
    }
  }, [response, requestData]);

  return (
    <Modal open={isOpen} onCancel={onClose} footer={null} destroyOnClose>
      {state && state.secretKey && requestData ? (
        <OTPCode
          onBack={() => setState(undefined)}
          email={requestData?.email}
        />
      ) : (
        <Content
          onSubmit={(values) => setRequestData(values)}
          setSignInOpen={setSignInOpen}
          onClose={onClose}
        />
      )}
    </Modal>
  );
}
